import React, { useState } from 'react';
import { Intl } from '@erecruit/core';
import { Resources } from '@erecruit/types';
import {
  Button,
  Form,
  FormItem,
  H1,
  Modal,
  ModalProps,
  Option,
  Select,
  TextArea,
} from '@erecruit/ui-kit';
import { ButtonContainer } from '@erecruit/modules';

const { FormattedMessage, injectIntl } = Intl;

const ModalTitle = (
  <H1>
    <FormattedMessage
      id={messageIds.vms.matchRecord.rejectModal.reasonDetails}
    />
  </H1>
);

const PageTitle = (
  <H1 color="headerTertiary">
    <FormattedMessage id={messageIds.vms.matchRecord.rejectModal.title} />
  </H1>
);

export interface RejectModalForm {
  rejectReason: string;
  additionalNote?: string;
}

export interface RejectModalProps extends Intl.InjectedIntlProps, ModalProps {
  onSubmit(values: RejectModalForm): void;
  rejectReasons?: Resources.MatchEndReason[];
}

const RejectModal = ({
  intl,
  onSubmit,
  rejectReasons,
  ...modalProps
}: RejectModalProps) => {
  const [commentRequired, setCommentRequired] = useState(false);

  return (
    <Modal
      {...modalProps}
      title={ModalTitle}
      pageTitle={PageTitle}
      footer={false}
      width="642px"
      destroyOnClose
    >
      <Form onValidFieldsSubmit={values => onSubmit(values as RejectModalForm)}>
        <FormItem
          id={nameof<RejectModalForm>(o => o.rejectReason)}
          label={intl.formatMessage({
            id: messageIds.vms.matchRecord.rejectModal.rejectReason,
          })}
          options={{
            rules: [{ required: true }],
          }}
        >
          <Select
            placeholder={intl.formatMessage({
              id: messageIds.vms.matchRecord.rejectModal.selectRejectReason,
            })}
            onSelect={(id: string) => {
              const commentRequired = rejectReasons?.find(
                ({ id: rejectReasonId }) => rejectReasonId === Number(id),
              )?.commentRequired;

              setCommentRequired(!!commentRequired);
            }}
          >
            {rejectReasons?.map(({ id, name }) => (
              <Option key={id}>{name}</Option>
            ))}
          </Select>
        </FormItem>
        <FormItem
          id={nameof<RejectModalForm>(o => o.additionalNote)}
          label={intl.formatMessage({
            id: messageIds.vms.matchRecord.rejectModal.additionalNote,
          })}
          options={{ rules: [{ required: commentRequired }] }}
        >
          <TextArea autoSize={{ minRows: 4 }} />
        </FormItem>
        <ButtonContainer>
          <Button size="large" onClick={modalProps.onCancel}>
            <FormattedMessage
              id={messageIds.vms.matchRecord.rejectModal.cancel}
            />
          </Button>
          <Button htmlType="submit" size="large" key="confirm" type="primary">
            <FormattedMessage
              id={messageIds.vms.matchRecord.rejectModal.reject}
            />
          </Button>
        </ButtonContainer>
      </Form>
    </Modal>
  );
};

export default injectIntl(RejectModal);
